import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ProfileService } from '@le_cedre/portal-lib';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class IsLoggedGuard implements CanActivate {
    isUserLoad$: Observable<boolean>;

    constructor(private profileService: ProfileService) {
        this.isUserLoad$ = this.profileService.uid$.pipe(
            filter((uid) => !!uid),
            take(1),
            map(() => true)
        );
    }

    canActivate(): Observable<boolean> {
        return this.isUserLoad$;
    }
}
